export default [
  {
    path: "my-admin",
    name: "myAdmin",
    component: () => import("@/views/adminPanel/pages/myAdmin/MyAdmin.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "blog-management",
    name: "blog-management",
    component: () =>
      import(
        "@/views/adminPanel/pages/myAdmin/components/pages/BlogManagement.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "contactUs",
    name: "contactUs",
    component: () =>
      import("@/views/adminPanel/pages/configurations/contact/Contact.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "project-management",
    name: "custom-project-management",
    component: () =>
      import(
        "@/views/adminPanel/pages/projectManagement/ProjectManagement.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "scope-Requirements",
    name: "scope-Requirements",
    component: () =>
      import(
        "@/views/adminPanel/pages/projectManagement/scopeRequirements.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "ProjectRegister",
    name: "ProjectRegister",
    component: () =>
      import("@/views/adminPanel/pages/projectManagement/Register.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "summaryreport",
    name: "summaryreport",
    component: () =>
      import(
        "@/views/adminPanel/pages/projectManagement/component/summaryreport.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "user-role",
    name: "user-role",
    component: () =>
      import("@/views/adminPanel/pages/configurations/user-role/UserRole.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "intellectualProperty",
    name: "intellectualProperty",
    component: () =>
      import(
        "@/views/adminPanel/pages/myAdmin/components/pages/IntellectualProperty.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "categories",
    name: "categories",
    component: () =>
      import("@/views/adminPanel/pages/myAdmin/components/pages/Category.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "whatsapp-bot",
    name: "whatsapp-bot",
    component: () =>
      import(
        "@/views/adminPanel/pages/myAdmin/components/pages/whatsapp/Home.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "whatsapp-report",
    name: "whatsapp-report",
    component: () =>
      import(
        "@/views/adminPanel/pages/myAdmin/components/pages/whasappreport/WhatsappReport.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "pick-template",
    name: "pick-template",
    component: () =>
      import(
        "@/views/adminPanel/pages/myAdmin/components/pages/whatsapp/components/PickTemplate.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "author",
    name: "author",
    component: () =>
      import("@/views/adminPanel/pages/elearning/author/Author.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "cources-category",
    name: "cources-category",
    component: () =>
      import(
        "@/views/adminPanel/pages/elearning/coursecategory/CourseCategory.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "cources",
    name: "cources",
    component: () =>
      import("@/views/adminPanel/pages/elearning/courses/Course.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "course-management",
    name: "courseManagement",
    component: () =>
      import(
        "@/views/adminPanel/pages/elearning/coursemanagement/Course-Management.vue"
      ),
  },
  {
    path: "testimonial",
    name: "testimonial",
    component: () =>
      import("@/views/adminPanel/pages/portfolio/testimonial/Testimonial.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "album",
    name: "album",
    component: () =>
      import("@/views/adminPanel/pages/portfolio/album/Album.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "category-management",
    name: "category-management",
    component: () =>
      import("@/views/adminPanel/pages/portfolio/category/Category.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "portfolio-management",
    name: "portfolioManagement",
    component: () =>
      import(
        "@/views/adminPanel/pages/portfolio/portfolioManagement/PortfolioManagement.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "attendance",
    name: "attendance",
    component: () =>
      import(
        "@/views/adminPanel/pages/elearning/courses/components/Attendance.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "customize/:id",
    name: "customize",
    component: () =>
      import(
        "@/views/adminPanel/pages/elearning/courses/components/Customize.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
];
